import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';

function getPath(parentNode, index, childrenKey) {
  if (!parentNode) return [index];
  return [].concat(_toConsumableArray(parentNode.path), [childrenKey, index]);
}

function walkTreeStrategy(_ref) {
  var data = _ref.data,
      _ref$childrenKey = _ref.childrenKey,
      childrenKey = _ref$childrenKey === void 0 ? 'children' : _ref$childrenKey,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 0 : _ref$level,
      _ref$getId = _ref.getId,
      getId = _ref$getId === void 0 ? function (item) {
    return item.id;
  } : _ref$getId,
      parentNode = _ref.parentNode,
      _ref$shouldWalkChildr = _ref.shouldWalkChildren,
      shouldWalkChildren = _ref$shouldWalkChildr === void 0 ? function () {
    return true;
  } : _ref$shouldWalkChildr,
      cb = _ref.cb;

  // eslint-disable-next-line no-loops/no-loops,no-plusplus
  for (var i = 0; i < data.length; i++) {
    var currLevel = level + 1;
    var children = data[i][childrenKey];
    var isGroup = children && !!children.length;
    var node = {
      index: i,
      id: getId(data[i]),
      data: data[i],
      path: getPath(parentNode, i, childrenKey),
      isGroup: isGroup,
      nestingLevel: currLevel,
      parentNode: parentNode || {
        isGroup: true,
        data: {
          children: data
        }
      }
    };
    cb(node);

    if (shouldWalkChildren(node) && children && children.length) {
      walkTreeStrategy({
        data: children,
        level: currLevel,
        parentNode: node,
        shouldWalkChildren: shouldWalkChildren,
        cb: cb
      });
    }
  }
}

export { walkTreeStrategy };
//# sourceMappingURL=walkStrategy.js.map
